import $ from "jquery";

class MobileMenu {
  constructor() {
    this.html = $("html");
    this.sidenav = $(".mobilemenu");
    this.hamburgermenu = $(".hamburger");
    this.overlay = $(".overlay");
    this.menuOpenClass = "mobilemenu--open";
    this.events();
  }

  events() {
    this.hamburgermenu.on("click", this.toggleMenu.bind(this));
    this.html.on("click", this.clickOutsideOfMenu.bind(this));
    this.sidenav.on("click", this.stopPropagation);
    this.hamburgermenu.on("click", this.stopPropagation);
    this.sidenav.find("a").on("click", this.closeMenu.bind(this));
  }

  toggleMenu(e) {
    if (this.sidenav.hasClass(this.menuOpenClass)) {
      this.closeMenu();
    } else {
      this.openMenu();
    }
  }

  openMenu() {
    this.sidenav.addClass(this.menuOpenClass);
    this.hamburgermenu.addClass("open");
    this.overlay.show();
  }

  closeMenu() {
    this.sidenav.removeClass(this.menuOpenClass);
    this.hamburgermenu.removeClass("open");
    this.overlay.hide();
  }

  clickOutsideOfMenu(e) {
    const isClickOutside = !$(e.target).closest(".mobilemenu").length && !$(e.target).closest(".hamburger").length;

    if (isClickOutside && this.sidenav.hasClass(this.menuOpenClass)) {
      this.closeMenu();
    }
  }

  stopPropagation(e) {
    e.stopPropagation();
  }
}

export default MobileMenu;
